import * as yup from "yup";

import { ExternalReportLinkRegistryFormVariables } from "@tenera/linkregistrymodels";
import { REQUIRED_FIELD_TEXT } from "../../LinkRegistryConstants";

export const externalReportLinkRegistryVariablesSchema: yup.SchemaOf<ExternalReportLinkRegistryFormVariables> = yup.object({
    brandingId: yup.string().required(REQUIRED_FIELD_TEXT),
    propertyId: yup.string().required(REQUIRED_FIELD_TEXT),
    propertyAddress: yup.string(),
    locationName: yup.string(),
    locationId: yup.string(),
    // createLocation and newLocation name are form only fields that are not being persisted
    createLocation: yup.boolean(),
    newLocationName: yup.string(),
}).test(
    "at-least-one-required",
    REQUIRED_FIELD_TEXT,
    (values, { createError }) => {
        if (values.createLocation && !values.newLocationName) {
            return createError({ path: "newLocationName", message: REQUIRED_FIELD_TEXT })
        } else if (!values.createLocation && !values.locationName) {
            return createError({ path: "locationId", message: REQUIRED_FIELD_TEXT })
        }
        return true;
    }
);
